module.exports = __webpack_public_path__ + "img/gamblers-anonymous-greyscale.52428ed0.svg";